module.exports = __webpack_public_path__ + "img/5-4.cb14743f.png";